(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      
      // Debug: check if header is found
      if (!this.header) {
        console.error('Header element not found!');
        return;
      }
      
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // --header-height positions the sticky collection filters (ECSR-927), so
      // a stale value parks the panel behind the header. The matchMedia listener
      // above only fires when the 990px breakpoint is crossed, which misses a
      // resize or zoom within a band that re-wraps the header, and misses the
      // reflow when webfonts land.
      if (typeof ResizeObserver !== 'undefined') {
        this.headerResizeObserver = new ResizeObserver(() => this.setHeaderHeight());
        this.headerResizeObserver.observe(this.header);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      const height = this.header.offsetHeight;

      // Write only on a real change. observe() delivers an initial observation,
      // so this would otherwise run twice on every load; the sticky/hidden class
      // swap re-measures on every crossing of the scroll threshold; and on a
      // collection page the value feeds the sticky sidebar's max-height, which
      // can reach document height -> classic scrollbar -> viewport width ->
      // header re-wrap. Comparing first keeps that from cycling and avoids
      // invalidating document style for no reason.
      if (height === this._lastHeaderHeight) return;
      this._lastHeaderHeight = height;

      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);

      if (this.headerResizeObserver) {
        this.headerResizeObserver.disconnect();
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Add sticky class when scrolled past header bounds (only if not always sticky)
      if (!this.headerIsAlwaysSticky) {
        // Use a more reliable threshold - when scrolled more than 5px for immediate response
        if (scrollTop > 5) {
          if (!this.header.classList.contains('shopify-section-header-sticky')) {
            this.header.classList.add('shopify-section-header-sticky');
          }
        } else {
          if (this.header.classList.contains('shopify-section-header-sticky')) {
            this.header.classList.remove('shopify-section-header-sticky');
          }
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'animate');
      // Don't remove shopify-section-header-sticky here as it's managed in onScroll
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Enhanced Megamenu Header Color Management
  document.addEventListener('DOMContentLoaded', function() {
    const enhancedMegamenuTriggers = document.querySelectorAll('.enhanced-megamenu-trigger');
    const header = document.querySelector('header.header.header-wrapper--absolute.header--top-center.header--mobile-center.header--has-menu.header--has-social.header--has-account.header--white-logo.header--white-icons.header--white-links.header--white-forms.tw-px-0');
    
    if (enhancedMegamenuTriggers.length > 0 && header) {
      enhancedMegamenuTriggers.forEach(trigger => {
        // Handle hover events
        trigger.addEventListener('mouseenter', function() {
          header.classList.add('megamenu-hover');
        });
        
        trigger.addEventListener('mouseleave', function() {
          header.classList.remove('megamenu-hover');
        });
        
        // Handle open/close events
        trigger.addEventListener('toggle', function() {
          if (this.open) {
            header.classList.add('megamenu-open');
          } else {
            header.classList.remove('megamenu-open');
          }
        });
      });
    }
  });

  // Secondary Nav Click Handler - Global function
  window.handleSecondaryNavClick = function(event, linkUrl, dropdownId) {
    event.preventDefault();
    
    const dropdown = document.getElementById(dropdownId);
    const isOpen = dropdown.hasAttribute('open');
    
    // Close all other dropdowns
    const allDropdowns = document.querySelectorAll('.secondary-nav__dropdown[open]');
    allDropdowns.forEach(dropdown => {
      if (dropdown.id !== dropdownId) {
        dropdown.removeAttribute('open');
      }
    });
    
    // Toggle current dropdown
    if (isOpen) {
      dropdown.removeAttribute('open');
      // Navigate to the link when closing
      setTimeout(() => {
        window.location.href = linkUrl;
      }, 100);
    } else {
      dropdown.setAttribute('open', '');
    }
  };

  } catch(e) { console.error(e); }
})();
})();
